// A project's progress from its milestones (deliverables), not from the project's task count (boss's task «تغییر نمایش
// پیشرفت در نودها», 2026-10-21; changed 2026-10-24; same rule as zofino-strapi src/projects/milestone-progress.ts): each
// milestone counts with the share of its own tasks that is done (a milestone marked done counts 100%), so 5 unfinished
// milestones with a task or two done each still show progress. Milestones are weighted by impactWeight (missing or
// non-positive = 1); archived milestones and tasks are left out.

export function milestonePercent(milestone) {
    if (milestone?.deliverableStatus === "done") return 100;
    const tasks = (Array.isArray(milestone?.tasks) ? milestone.tasks : []).filter((task) => task && !task.archivedAt);
    if (!tasks.length) return 0;
    return (tasks.filter((task) => task.taskStatus === "done").length / tasks.length) * 100;
}

export function milestoneProgress(milestones) {
    const active = (Array.isArray(milestones) ? milestones : []).filter((milestone) => milestone && !milestone.archivedAt);
    if (!active.length) return {progress: null, milestones: 0, doneMilestones: 0};
    let weighted = 0;
    let weights = 0;
    active.forEach((milestone) => {
        const weight = Number(milestone.impactWeight) > 0 ? Number(milestone.impactWeight) : 1;
        weighted += milestonePercent(milestone) * weight;
        weights += weight;
    });
    return {
        progress: Math.round(weighted / weights),
        milestones: active.length,
        doneMilestones: active.filter((milestone) => milestonePercent(milestone) === 100).length,
    };
}
